(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zk-taster-showcase"] && !Shopify.designMode) return;
  try {
    
class ZKTasterCarousel extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.list = this.querySelector('.zk-tasters__products');
    if (!this.list) return;
    this.list.addEventListener('wheel', (event) => {
      if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      const multiplier = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.list.clientWidth : 1;
      const delta = event.deltaY * multiplier;
      const max = this.list.scrollWidth - this.list.clientWidth;
      if (max <= 1 || (delta < 0 && this.list.scrollLeft <= 1) || (delta > 0 && this.list.scrollLeft >= max - 1)) return;
      event.preventDefault();
      this.list.scrollLeft += delta;
    }, { ...options, passive: false });
    this.list.addEventListener('keydown', (event) => {
      if (event.target !== this.list) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.list.scrollBy({ left: (event.key === 'ArrowLeft' ? -1 : 1) * this.list.clientWidth / 2, behavior: 'instant' });
      }
    }, options);
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('zk-taster-carousel')) customElements.define('zk-taster-carousel', ZKTasterCarousel);

  } catch(e) { console.error(e); }
})();
})();
